/**
 * IMPORTS
 */
import type {
  IAnexoMensagem,
  IConvidarParticipantePayload,
  IResponderConversaPayload,
} from "@/interface/conversa-cliente";
import { conversaClienteRepository } from "@/repositories/conversa-cliente";

/*
 * Diferente dos handle* legados (que devolvem o erro como valor), estes relançam:
 * quem trata é o react-query (isError / onError).
 */

const handleListarMinhasMensagens = (
  accessToken: string,
  pagina: number,
  itensPorPagina: number,
  busca?: string
) => conversaClienteRepository.getListarMinhasMensagens(accessToken, pagina, itensPorPagina, busca);

const handleResponderMinhasMensagens = (accessToken: string, payload: IResponderConversaPayload) =>
  conversaClienteRepository.postResponderMinhasMensagens(accessToken, payload);

const handleBuscarImagemAnexo = (accessToken: string, mensagemId: number, anexoId: number) =>
  conversaClienteRepository.getBuscarConteudoAnexo(accessToken, mensagemId, anexoId);

/** Baixa o anexo com o nome original e libera o blob em seguida. */
const handleBaixarAnexo = async (
  accessToken: string,
  mensagemId: number,
  anexo: IAnexoMensagem
): Promise<void> => {
  const conteudo = await conversaClienteRepository.getBuscarConteudoAnexo(
    accessToken,
    mensagemId,
    anexo.id
  );
  const url = URL.createObjectURL(conteudo);
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = anexo.nome_original;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
};

const handleBuscarEstadoConversa = (accessToken: string) =>
  conversaClienteRepository.getEstadoConversa(accessToken);

const handleListarCandidatosConvite = (accessToken: string, busca?: string) =>
  conversaClienteRepository.getListarCandidatosConvite(accessToken, busca);

const handleConvidarParticipante = (accessToken: string, payload: IConvidarParticipantePayload) =>
  conversaClienteRepository.postConvidarParticipante(accessToken, payload);

const handleRemoverParticipante = (accessToken: string, participanteId: number) =>
  conversaClienteRepository.deleteRemoverParticipante(accessToken, participanteId);

const handleInativarParticipante = (accessToken: string, participanteId: number) =>
  conversaClienteRepository.postInativarParticipante(accessToken, participanteId);

const handleReativarParticipante = (accessToken: string, participanteId: number) =>
  conversaClienteRepository.postReativarParticipante(accessToken, participanteId);

const handleResponderConvite = (
  accessToken: string,
  conviteId: number,
  resposta: "aceitar" | "recusar"
) => conversaClienteRepository.postResponderConvite(accessToken, conviteId, resposta);

const handleListarNotificacoes = (accessToken: string, pagina: number, itensPorPagina: number) =>
  conversaClienteRepository.getListarNotificacoes(accessToken, pagina, itensPorPagina);

const handleContarNotificacoesNaoLidas = (accessToken: string) =>
  conversaClienteRepository.getContarNotificacoesNaoLidas(accessToken);

const handleMarcarNotificacaoLida = (accessToken: string, id: number) =>
  conversaClienteRepository.patchMarcarNotificacaoLida(accessToken, id);

const handleMarcarTodasNotificacoesLidas = (accessToken: string) =>
  conversaClienteRepository.patchMarcarTodasNotificacoesLidas(accessToken);

/**
 * EXPORTS
 */
export {
  handleBaixarAnexo,
  handleBuscarEstadoConversa,
  handleBuscarImagemAnexo,
  handleContarNotificacoesNaoLidas,
  handleConvidarParticipante,
  handleInativarParticipante,
  handleListarCandidatosConvite,
  handleListarMinhasMensagens,
  handleListarNotificacoes,
  handleMarcarNotificacaoLida,
  handleMarcarTodasNotificacoesLidas,
  handleReativarParticipante,
  handleRemoverParticipante,
  handleResponderConvite,
  handleResponderMinhasMensagens,
};
